.JournalEntries {
    display: flex;
    flex-direction: column;
    gap: 150px;
    margin-top: 150px;
    padding-bottom: 150px;

    $gap: 40px;

    .day {
        display: flex;
        flex-direction: row;
        gap: $gap;

        .dayEntries {
            flex: 1;
        }
    }

    .journalEntry {
        font-size: 2rem;
    }

    .feedback {
        padding: 1em;
        border-left: 1px solid #ccc;
    }
    .entry {
        margin-bottom: 1em;
        position: relative;

        button,
        a.extLink {
            background-color: transparent;
            border: 1px solid var(--border);
            font-size: 11px;
            color: var(--primary-foreground);
            padding: 0.25em 0.5em;
            text-decoration: none;
            line-height: 1.5;
            display: inline;

            margin-right: 0.5em;
        }
    }

    .createdAt {
        font-size: 0.8rem;
        width: 1em;
        // font-weight: bold;
        position: relative;
        padding-left: $gap;
        font-family: 'Gill Sans', 'Gill Sans MT', Calibri, 'Trebuchet MS', sans-serif;

        &::before {
            content: '';
            position: absolute;
            top: 0;
            left: 0;
            width: 1px;
            height: 4em;
            background-color: #ccc;
        }
    }

    .actions {
        margin-top: 1rem;
        .btn {
            cursor: pointer;
            $size: 15px;
            width: $size;
            height: $size;
            text-align: center;
            line-height: $size;

            color: var(--primary-foreground);
            border: 1px solid var(--border);
        }
    }
}
